/**
 * The two small pieces every card of the booking-flow editor is drawn with —
 * a numbered heading and a switch with its note. Moved out of `FlowEditor.tsx`
 * in Wave 27C (T-5.77) when the payment and documents cards became files of
 * their own (`PaymentCard.tsx`, `DocumentsCard.tsx`), so the three draw alike
 * and none imports another.
 */

import { Switch } from '@fiveox/ui'
import type { ReactNode } from 'react'

export function CardHead({ n, title, note }: { n: number; title: string; note: string }) {
  return (
    <div className="flex items-start gap-3">
      <span className="bg-primary/10 text-primary flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold">
        {n}
      </span>
      <div className="min-w-0">
        <h2 className="text-foreground text-base font-semibold">{title}</h2>
        <p className="text-muted-foreground text-sm">{note}</p>
      </div>
    </div>
  )
}

export function SwitchRow({
  label,
  note,
  name,
  checked,
  disabled,
  reason = false,
  onChange,
}: {
  label: string
  note: ReactNode
  name: string
  checked: boolean
  disabled: boolean
  /** The note is why the switch is off. */
  reason?: boolean
  onChange: (on: boolean) => void
}) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <p className="text-foreground text-sm font-medium">{label}</p>
        <p className="text-muted-foreground text-xs" data-switch-note={name} data-reason={reason ? '' : undefined}>
          {note}
        </p>
      </div>
      <Switch
        srLabel={label}
        data-switch={name}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
    </div>
  )
}
